import React from "react";
import "./AboutFinkraft.scss";
import { useNavigate } from "react-router-dom";

interface Step {
  icon: React.ReactNode;
  title: string;
  description: string;
}

interface StepsComponentProps {
  title: string;
  subtitle: string;
  description: string;
  steps: Step[];
  buttonText?: string;
  onButtonClick?: () => void;
}

const AboutFinkraft: React.FC<StepsComponentProps> = ({
  title,
  subtitle,
  description,
  steps,
  buttonText = "Visit Finkraft",
}) => {
  const navigate = useNavigate();
  const onButtonClick = () => {
    window.open("https://finkraft.ai", "_blank");
  };
  return (
    <section className="steps-componentAbout">
      <div className="steps-content">
        <div className="steps-headerAbout">
          <span className="steps-subtitleAbout">{subtitle}</span>
          <h2 className="steps-titleAbout">{title}</h2>
          <p className="steps-descriptionAbout">{description}</p>

          <button className="steps-button" onClick={onButtonClick}>
            {buttonText}
          </button>
        </div>

        <div className="steps-gridAbout">
          {steps.map((step, index) => (
            <div key={index} className="step-item">
              <div className="step-icon-container">{step.icon}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutFinkraft;
